import { createUseStyles } from 'react-jss'
import HTMLParse from 'react-html-parser'
import EmblaCarousel from '@/components/__new/EmblaCarousel'
import DelayLink from '@/components/DelayLink'
import { fromUtcToDate } from '@/utils/date'
import { decodeEntities } from '@/utils/decodeEntities'
import style from './style'

const useStyles = createUseStyles(style)

function PostCarousel({ title, items }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className="container">
        <div className="grid">
          {title ? (
            <span className={`${classes.pretitle} pretit`}>
              {HTMLParse(title)}
            </span>
          ) : null}
          {items?.length > 3 ? (
            <EmblaCarousel
              className={classes.embla}
              items={items.map((item) => ({
                id: item.id,
                link: item.link,
                image: item.featured_image,
                imageAlt: item.featured_image_alt,
                imageTitle: item.featured_image_title,
                pretitle: fromUtcToDate(item?.date),
                title: item.title?.rendered,
                description: item.excerpt?.rendered,
                width: 400,
                height: 480,
              }))}
              editorialTemplate
            />
          ) : (
            <div className={classes.postGrid}>
              {items.map((item) => (
                <div
                  key={item.id}
                  className={classes.postItem}
                >
                  <DelayLink
                    to={item.link}
                    className={classes.postImage}
                  >
                    <img // eslint-disable-line
                      src={item.featured_image}
                      className={classes.image}
                      {...(item.featured_image_alt ? { alt: decodeEntities(item.featured_image_alt) } : {})}
                      {...(item.featured_image_title ? { title: decodeEntities(item.featured_image_title) } : {})}
                    />
                  </DelayLink>
                  <div className={classes.postContent}>
                    <span className={`${classes.pretitle} pretit`}>
                      {fromUtcToDate(item.date)}
                    </span>
                    <h4 className={classes.h4}>
                      <DelayLink to={item.link}>
                        {HTMLParse(item.title?.rendered)}
                      </DelayLink>
                    </h4>
                    <div className={classes.p}>
                      {HTMLParse(item.excerpt?.rendered)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PostCarousel
